import axios from 'services/axios';
import jwtDecode from 'jwt-decode';
import { API } from 'services/constants/';
import { push as PushRouter } from 'connected-react-router';

const createAction = name => ({
  CHECK_JWT_SUCCESS: `${name}_CHECK_JWT_SUCCESS`,
  CHECK_JWT_FAILED: `${name}_CHECK_JWT_FAILED`,
  LOGIN_PENDING: `${name}_LOGIN_PENDING`,
  LOGIN_SUCCESS: `${name}_LOGIN_SUCCESS`,
  LOGIN_FALIED: `${name}_LOGIN_FALIED`,
  LOGOUT_SUCCESS: `${name}_LOGOUT_SUCCESS`
});

export const AUTHEN = createAction('AUTHEN');

// try {
//   await axios
//     .get(API.GET_COMPANY)
//     .then(res => res.data)
//     .catch(error => Promise.reject(error.response));

//   dispatch({ type: AUTHEN.CHECK_JWT_SUCCESS, payload: jwtDecode(token) });
//   dispatch(PushRouter(path));
// } catch (error) {
//   if (error.status === 401) {
//     dispatch(AuthenLogout());
//   }
// }
export const AuthCheckJWT = path => async dispatch => {
  const token = localStorage.getItem('finsense_token');
  if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    dispatch({ type: AUTHEN.CHECK_JWT_SUCCESS, payload: jwtDecode(token) });
    dispatch(PushRouter(path));
  } else {
    dispatch({ type: AUTHEN.CHECK_JWT_FAILED });
    dispatch(PushRouter('/auth/login'));
  }
};

// export function addEvent(newEvent)
// {
//     return (dispatch, getState) => {
//         const request = axios.post('/api/calendar-app/add-event', {
//             newEvent
//         });
//         return request.then((response) =>
//             Promise.all([
//                 dispatch({
//                     type: ADD_EVENT
//                 })
//             ]).then(() => dispatch(getEvents()))
//         );
//     };
// }

export const AuthenLogin = data => async dispatch => {
  dispatch({ type: AUTHEN.LOGIN_PENDING });
  try {
    const params = { ...data };

    // const token = await
    axios
      .post(API.LOGIN, params, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(res => {
        //res.data.token
        const token = res.data.token;
        localStorage.setItem('finsense_token', token);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

        dispatch({
          type: AUTHEN.LOGIN_SUCCESS,
          payload: jwtDecode(token)
        });

        dispatch(PushRouter('/dashboard'));
      })
      .catch(error => Promise.reject(error));
    // localStorage.setItem('finsense_token', token);
    // axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

    // dispatch({
    //   type: AUTHEN.LOGIN_SUCCESS,
    //   payload: jwtDecode(token)
    // });

    // dispatch(PushRouter('/dashboard'));
  } catch (error) {
    dispatch({
      type: AUTHEN.LOGIN_FALIED,
      error
    });
  }
};

export const AuthenLogout = () => dispatch => {
  localStorage.removeItem('finsense_token');
  delete axios.defaults.headers.common['Authorization'];
  dispatch({ type: AUTHEN.LOGOUT_SUCCESS });
  dispatch(PushRouter('/auth/login'));
};
